import { render, staticRenderFns } from "./TwoCol5050Editor.vue?vue&type=template&id=28ff348a&"
import script from "./TwoCol5050Editor.vue?vue&type=script&lang=js&"
export * from "./TwoCol5050Editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports